/* PA Card — mobile swipe + (+) sizes overlay */
(function () {
  function setupCard(card) {
    if (card.__paCardInit) return;
    card.__paCardInit = true;

    const slider = card.querySelector('[data-card-slider]');
    const track = card.querySelector('[data-card-track]');
    const dots = card.querySelectorAll('[data-card-dots] [data-dot]');
    const plus = card.querySelector('[data-card-plus]');
    const overlay = card.querySelector('[data-card-sizes-overlay]');
    const link = card.querySelector('[data-card-link]');

    /* Update dots while scrolling track */
    if (track && dots.length) {
      let raf;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
          raf = null;
        });
      }, { passive: true });
    }

    /* Plus button toggles sizes overlay (mobile). Prevent navigating the link. */
    if (plus && overlay) {
      plus.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const open = card.hasAttribute('data-sizes-open');
        if (open) {
          card.removeAttribute('data-sizes-open');
          plus.setAttribute('aria-expanded', 'false');
          overlay.setAttribute('aria-hidden', 'true');
        } else {
          card.setAttribute('data-sizes-open', '');
          plus.setAttribute('aria-expanded', 'true');
          overlay.setAttribute('aria-hidden', 'false');
        }
      });
      /* Tap outside overlay (still inside the card) closes it */
      card.addEventListener('click', (e) => {
        if (!card.hasAttribute('data-sizes-open')) return;
        if (e.target.closest('[data-card-plus]')) return;
        if (e.target.closest('.pa-card__size')) return;
        if (e.target.closest('[data-card-sizes-overlay]') && !e.target.closest('.pa-card__sizes-grid')) {
          e.preventDefault();
          e.stopPropagation();
          card.removeAttribute('data-sizes-open');
          plus.setAttribute('aria-expanded', 'false');
          overlay.setAttribute('aria-hidden', 'true');
        }
      });
    }

    /* Block link navigation when overlay is open */
    if (link) {
      link.addEventListener('click', (e) => {
        if (card.hasAttribute('data-sizes-open')) {
          e.preventDefault();
        }
      });
    }

    /* Quick-buy: clicking a size button adds variant to cart and opens drawer */
    card.querySelectorAll('[data-quick-buy]').forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        const id = btn.dataset.variantId;
        if (!id) return;
        btn.disabled = true;
        const original = btn.textContent;
        btn.textContent = '...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }),
          });
          if (!res.ok) throw new Error('add failed');
          /* Close overlay */
          if (plus && overlay) {
            card.removeAttribute('data-sizes-open');
            plus.setAttribute('aria-expanded', 'false');
            overlay.setAttribute('aria-hidden', 'true');
          }
          /* Refresh + open cart drawer */
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            if (typeof drawer.refresh === 'function') await drawer.refresh();
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          console.error('Quick-buy failed', err);
        } finally {
          btn.disabled = false;
          btn.textContent = original;
        }
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-card]').forEach(setupCard);
  }

  window.shopifyReinitCards = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  /* Re-init on Shopify section reload (theme editor) */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
